const appConfig = {
  // apiPrefix: 'http://localhost:5003/api/',
  apiPrefix: "https://visitor.5techg.com/api/",
  // apiBaseURL: 'https://ra-masale-new-visitor-server.onrender.com',
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: true,
};

export default appConfig;
